<template>
  <div
    v-if="currThemeObj"
    :style="{
      '--mixtmt_whiteColor': currThemeObj.cssStyle.whiteColor,
      '--mixtmt_blackColor': currThemeObj.cssStyle.blackColor,
      '--mixtmt_greyColor0': currThemeObj.cssStyle.greyColor0,
      '--mixtmt_greyColor2': currThemeObj.cssStyle.greyColor2,
      '--mixtmt_greyColor3': currThemeObj.cssStyle.greyColor3,
      '--mixtmt_greyColor4': currThemeObj.cssStyle.greyColor4,
      '--mixtmt_greyColor5': currThemeObj.cssStyle.greyColor5,
      '--mixtmt_greyColor6': currThemeObj.cssStyle.greyColor6,
      '--mixtmt_greyColor7': currThemeObj.cssStyle.greyColor7,
      '--mixtmt_greyColor8': currThemeObj.cssStyle.greyColor8,
      '--mixtmt_greyColor9': currThemeObj.cssStyle.greyColor9,
      '--mixtmt_greyColor11': currThemeObj.cssStyle.greyColor11,
      '--mixtmt_greyColor12': currThemeObj.cssStyle.greyColor12,
      '--mixtmt_greyColor13': currThemeObj.cssStyle.greyColor13,
      '--mixtmt_greyColor14': currThemeObj.cssStyle.greyColor14,
      '--mixtmt_errColor': currThemeObj.cssStyle.errColor,
      '--mixtmt_successColor': currThemeObj.cssStyle.successColor,
      '--mixtmt_mainColor': currThemeObj.cssStyle.mainColor,
      '--mixtmt_mainColor0': currThemeObj.cssStyle.mainColor0,
      '--mixtmt_mainColor2': currThemeObj.cssStyle.mainColor2,
      '--mixtmt_mainColor3': currThemeObj.cssStyle.mainColor3,
      '--mixtmt_mainColor4': currThemeObj.cssStyle.mainColor4,
      '--mixtmt_mainColor5': currThemeObj.cssStyle.mainColor5,
      '--mixtmt_mainColor6': currThemeObj.cssStyle.mainColor6,
      '--mixtmt_mainColor7': currThemeObj.cssStyle.mainColor7,
      '--mixtmt_mainColor8': currThemeObj.cssStyle.mainColor8,
      '--mixtmt_subColor_main05': currThemeObj.cssStyle.subColor_main05,
      '--mixtmt_greyColor_main': currThemeObj.cssStyle.greyColor_main,
      '--mixtmt_combatBar1_1': currThemeObj.cssStyle.combatBar1_1,
      '--mixtmt_combatBar1_2': currThemeObj.cssStyle.combatBar1_2,
      '--mixtmt_subColor_main': currThemeObj.cssStyle.subColor_main,
      '--mixtmt_greyColor9': currThemeObj.cssStyle.greyColor9,
      '--mixtmt_subColor1_1': currThemeObj.cssStyle.subColor1_1,
      '--mixtmt_subColor1_2': currThemeObj.cssStyle.subColor1_2,
      '--mixtmt_subColor1_3': currThemeObj.cssStyle.subColor1_3,
      '--mixtmt_selectInputActColor': currThemeObj.cssStyle.selectInputActColor,
      '--mixtmt_cupFootball_customColor1':
        currThemeObj.cssStyle.cupFootball_customColor1,

      '--mixtmt_footer_bg': `url(/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/footer_bg.png)`,
      '--mixtmt_ball_ver_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ball_ver_bg.png')`,
      '--mixtmt_ball_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ball_bg.png')`,
      '--mixtmt_ball_border_bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ball_border_bg.png')`,
      '--mixtmt_scheduleMatchList_dateBg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/scheduleMatchList_dateBg.png')`,
      '--mixtmt_dataOverview_floor1_pic': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/dataOverview_floor1_pic.png')`,
      '--mixtmt_dataOverview_floor2_pic': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/dataOverview_floor2_pic.png')`,
      '--mixtmt_echarts_shootDis_ExpetGoal_homeColor':
        currThemeObj.cssStyle.echarts_shootDis_ExpetGoal_homeColor,
      '--mixtmt_echarts_shootDis_ExpetGoal_awayColor':
        currThemeObj.cssStyle.echarts_shootDis_ExpetGoal_awayColor,
      '--mixtmt_echarts_footBallPlaygroundColor':
        currThemeObj.cssStyle.echarts_footBallPlaygroundColor,
      '--mixtmt_echarts_footBallPlaygroundBgColor':
        currThemeObj.cssStyle.echarts_footBallPlaygroundBgColor,
      '--mixtmt_table_headerBg': currThemeObj.cssStyle.table_headerBg,
      '--mixtmt_table_headerColor': currThemeObj.cssStyle.table_headerColor,
      '--mixtmt_table_publicBtnColor':
        currThemeObj.cssStyle.table_publicBtnColor,
      '--mixtmt_table_hoverRowColorBg':
        currThemeObj.cssStyle.table_hoverRowColorBg,
      '--mixtmt_table_hoverRowColor': currThemeObj.cssStyle.table_hoverRowColor,
      '--mixtmt_table_rowColor': currThemeObj.cssStyle.table_rowColor,

      '--mixtmt_matchEvent_redCard_color':
        currThemeObj.cssStyle.matchEvent_redCard_color,
      '--mixtmt_matchEvent_yellowCard_color':
        currThemeObj.cssStyle.matchEvent_yellowCard_color,
      '--mixtmt_lineup_playgroundArea_color1':
        currThemeObj.cssStyle.lineup_playgroundArea_color1,
      '--mixtmt_lineup_playgroundArea_color2':
        currThemeObj.cssStyle.lineup_playgroundArea_color2,
      '--mixtmt_lineup_playgroundArea_color3':
        currThemeObj.cssStyle.lineup_playgroundArea_color3,
    }"
  >
    <div v-text="themeItem.graphicsId"></div>
    <div
      class="autoExportPngMain"
      :style="`width:${globalQuery.width}px;height:${globalQuery.height}px`"
      ref="autoExportPngMain"
    >
      <!-- graphicsId: 16 -- 射门分布 -->
      <CANVAS_SHOOTINGSTEREOGRAM
        v-if="themeItem.graphicsId == 17 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></CANVAS_SHOOTINGSTEREOGRAM>

      <!-- graphicsId:17  -- 横向 进球控球链 -->
      <CANVAS_BALLCONTROLCHAIN
        v-if="themeItem.graphicsId == 18 && isMounted"
        :datas="themeItem"
        :scale="1"
        :isAutoExportPng="true"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></CANVAS_BALLCONTROLCHAIN>

      <!-- graphicsId: 19 -- 防守区域 -->
      <CANVAS_REGIONALCOVERAGE
        v-if="themeItem.graphicsId == 19 && isMounted"
        @uploadData="uploadDataHandler"
        :isAutoExportPng="true"
        :currThemeObj="currThemeObj"
        :datas="themeItem"
      ></CANVAS_REGIONALCOVERAGE>

      <!-- graphicsId:20  -- 横向 跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 20 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></HEATMAP>

      <!-- graphicsId: 25 -- 胜率预测 -->
      <WINRATEPREDICTION_BAR
        v-if="themeItem.graphicsId == 25 && isMounted"
        :isAutoExportPng="true"
        :datas="themeItem"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></WINRATEPREDICTION_BAR>

      <!-- graphicsId: 27 -- 比赛态势 -->
      <MATCHSTATE_KEYEVENT_BAR
        v-if="themeItem.graphicsId == 27 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></MATCHSTATE_KEYEVENT_BAR>

      <!-- graphicsId: 28 -- 射门分布及期望进球 -->
      <SHOOTDIS_EXPECTEDGOAL_SCATTER
        v-if="themeItem.graphicsId == 28 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :isTipFlag="false"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></SHOOTDIS_EXPECTEDGOAL_SCATTER>

      <!-- graphicsId: 29 -- 球员平均占位 -->
      <PLAYER_AVERAGEROCCUPANCY_SCATTER
        v-if="themeItem.graphicsId == 29 && isMounted"
        :isAutoExportPng="true"
        :datas="themeItem"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></PLAYER_AVERAGEROCCUPANCY_SCATTER>

      <!-- graphicsId: 32 -- 传球风格 -->
      <PASSINGSTYLE_PIE
        v-if="themeItem.graphicsId == 32"
        :isAutoExportPng="true"
        :isTipFlag="false"
        :datas="themeItem"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></PASSINGSTYLE_PIE>

      <!-- graphicsId:33  -- 横向 球队跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 33 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        :heatWeight="0.35"
        @uploadData="uploadDataHandler"
      ></HEATMAP>

      <!-- graphicsId:34  -- 横向 球员跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 34 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        :heatWeight="0.45"
        @uploadData="uploadDataHandler"
      ></HEATMAP>

      <SITUATION_MAP
        v-if="themeItem.graphicsId == 41 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        :heatWeight="0.35"
        @uploadData="uploadDataHandler"
      ></SITUATION_MAP>

      <HTML_SHOOTANALYSIS
        v-if="themeItem.graphicsId == 42 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></HTML_SHOOTANALYSIS>

       <!-- graphicsId: 35 -- 网球-球员数据对比【雷达图】 -->
      <TENNIS_RADAR_PLAYERINFOR
        v-if="themeItem.graphicsId == 35 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        :currThemeObj="currThemeObj"
        @uploadData="uploadDataHandler"
      ></TENNIS_RADAR_PLAYERINFOR>

      <!-- graphicsId:  -- 反击效率 -->
      <!-- <CANVAS_SCATTER_COORDINATSYS
        v-if="themeItem.graphicsId == 11 && isMounted"
        @uploadData="uploadDataHandler"
        :isAutoExportPng="true"
        :datas="themeItem"
      ></CANVAS_SCATTER_COORDINATSYS> -->

      <!-- graphicsId:  -- 横向 期望进球 -->
      <!-- <CANVAS_GRAPH_EXPECTGOAL
        v-if="themeItem.graphicsId == 12 && isMounted"
        :datas="themeItem"
        :isAutoExportPng="true"
        :tipFlag="false"
        @uploadData="uploadDataHandler"
      ></CANVAS_GRAPH_EXPECTGOAL> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import datas from '@components/football/echarts/ballControlChain/ballControlChain.json'
// import cup_base_data_mixin from '@mixins/cup_base_data'
import HEATMAP from '@components/football/heatMap/cup_heatMap.vue'
import SITUATION_MAP from '@components/football/SituationMap.vue'
import HTML_SHOOTANALYSIS from '@components/football/html/HTML_SHOOTANALYSIS/index.vue'
import CANVAS_SHOOTINGSTEREOGRAM from '@components/football/canvas/shootingStereogram/index.vue'
import CANVAS_REGIONALCOVERAGE from '@components/football/canvas/regionalCoverage/index.vue'
import CANVAS_BALLCONTROLCHAIN from '@components/football/echarts/ballControlChain/index.vue'
import CANVAS_SCATTER_COORDINATSYS from '@components/football/echarts/scatter/coordinateSystemScatter.vue'
import CANVAS_GRAPH_EXPECTGOAL from '@components/football/echarts/graph/expectGoalScatter.vue'
import MATCHSTATE_KEYEVENT_BAR from '@components/football/echarts/bar/matchState_keyEvent_bar.vue'
import PLAYER_AVERAGEROCCUPANCY_SCATTER from '@components/football/echarts/scatter/player_averageOccupancy_scatter.vue'
import SHOOTDIS_EXPECTEDGOAL_SCATTER from '@components/football/echarts/scatter/shootingDistribution_expectedGoal_scatter.vue'
import WINRATEPREDICTION_BAR from '@components/football/echarts/bar/winRatePrediction_bar.vue'
import PASSINGSTYLE_PIE from '@components/football/echarts/pie/passingStyle_pie.vue'
import TENNIS_RADAR_PLAYERINFOR from '@components/tennis/echarts/PlayerInforRadar.vue'

import {
  https_package_dataByDataItemID,
  https_package_uploadImage,
} from '@api/platfrom_base_api'

export default {
  beforeRouteEnter(to, from, next) {
    // console.debug(from)
    if (to.query.dataItemId && to.query.width && to.query.height) {
      console.debug(to)
      next((vm) => {
        vm.sportType = to.query.sportType
        vm.pathModule = to.query.pathModule
        vm.cid = to.query.cid
        vm.sid = to.query.sid
        vm.globalQuery.dataItemId = to.query.dataItemId
        vm.globalQuery.width = to.query.width - 0
        vm.globalQuery.height = to.query.height - 0
        vm.initHttp()
      })
    } else {
      next((vm) => {
        vm.$message.error('参数异常')
      })
    }
  },
  name: 'autoExportPng',
  components: {
    HEATMAP,
    SITUATION_MAP,
    HTML_SHOOTANALYSIS,
    CANVAS_SHOOTINGSTEREOGRAM,
    CANVAS_BALLCONTROLCHAIN,
    CANVAS_SCATTER_COORDINATSYS,
    CANVAS_GRAPH_EXPECTGOAL,
    CANVAS_REGIONALCOVERAGE,
    MATCHSTATE_KEYEVENT_BAR,
    PLAYER_AVERAGEROCCUPANCY_SCATTER,
    SHOOTDIS_EXPECTEDGOAL_SCATTER,
    WINRATEPREDICTION_BAR,
    PASSINGSTYLE_PIE,
    TENNIS_RADAR_PLAYERINFOR,
  },
  // mixins: [cup_base_data_mixin],
  data() {
    return {
      themeItem: {
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      },
      isMounted: false, //dom是否生成
      globalQuery: {
        dataItemId: null,
        width: null,
        height: null,
      },
      postUploadObj: {
        dataItemId: null,
        imageCode: [], //存储图片 base64 data 数组
        // legendData: [], //存储图片上图例数据
      },
      uploadNumber: 2, // 上传次数
      autoExportPngMain: null, //
      axiosBaseUrl: null,
      curTimeZoneItem: null,
      sportType: null,
      pathModule: null,
      cid: null,
      sid: null,
      currThemeObj: null,
    }
  },
  created() {
    // this.themeItem = datas
    this.query = this.$route.query ? this.$route.query : {}
    this.axiosBaseUrl = this.query.axiosBaseUrl ? this.query.axiosBaseUrl : null
    this.getCurrThemeObjHandler()
    console.debug(this.currThemeObj)
  },
  mounted() {
    // this.currThemeObj =
    //   this.$dynamicConfig.includeTheme.football.FIFAWorldCup_109[0]
    this.getCurrThemeObjHandler()
    console.debug(this.currThemeObj)
    this.$nextTick(() => {
      this.isMounted = true
      this.autoExportPngMain = this.$refs.autoExportPngMain
    })
  },
  methods: {
    async initHttp() {
      await this.getDataByDataItemID() //获取图表数据
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    getCurrThemeObjHandler() {
      if (this.sportType && this.pathModule && this.cid && this.sid) {
        const competitionItem =
          this.$dynamicConfig.includeTheme[this.sportType][
            `${this.pathModule}_${this.cid}`
          ]
        let index = 0

        if (competitionItem && competitionItem.length > 0) {
          competitionItem.forEach((cItem, cIndex) => {
            if (cItem.sid === this.sid) {
              index = cIndex
            }
          })
        }
        console.debug('competitionItem:', competitionItem, index)
        this.currThemeObj = competitionItem[index]
      }
    },
    getDataByDataItemID() {
      // let id10_1 = '011e80b5c3c54c10ae9eed75c85f0057'  //热力图
      // let id10_2 = '0cc28567322b436dba49f6ba17aba5fd'  //热力图
      // let id21_1 = '014194fa9a1449f28256dd7c4972bde8'  //控球链
      // let id21_2 = '007c7a4d72334cacaeddc9929723350d'  //控球链
      // let id22 = 'b8dff4a79a5842319dbce928108a8d6a'  //传球网络
      // let id23_1 = '17f05bd9d1844c488827b061c7d9645f'  //防守覆盖
      // let id23_2 = '826d8eecc46b45f3be02d9a78aed9ee0'  //防守覆盖

      let $dataByDataItemID = {
        dataItemId: this.globalQuery.dataItemId,
      }
      https_package_dataByDataItemID(
        this.axiosBaseUrl,
        this.$axios,
        $dataByDataItemID
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.themeItem = res.data[0].dataSearchResultModel
            // this.main.appendChild(`<div>${this.globalQuery.dataItemId}</div>`);
          }
          console.debug('echartsData callback', JSON.stringify(this.themeItem))
        })
        .catch((error) => {})
    },
    postUploadImage(postObj) {
      console.debug(postObj)
      let postJson = JSON.stringify(postObj)
      console.debug(postJson)
      // let cancel
      // {
      //     cancelToken: new axios.CancelToken(function executor(c) {
      //         cancel = c
      //         cancel();
      //         console.debug(c)
      //         // 这个参数 c 就是CancelToken构造函数里面自带的取消请求的函数，这里把该函数当参数用
      //     })
      // }
      https_package_uploadImage(this.axiosBaseUrl, this.$axios, postObj)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '图片上传成功',
              type: 'success',
            })
          }
          console.debug('upload_message', res.message)
          // setTimeout(() => {
          //     location.reload(true);
          // }, 10000)
        })
        .catch((error) => {
          // console.debug('uploadFail -- 201', error, typeof error)
          // if(error.toString().indexOf('timeout') !== -1 && this.uploadNumber > 0) {
          //     this.postUploadImage(this.postUploadObj);
          //     this.uploadNumber = this.uploadNumber - 1;
          // }
        })
    },
    uploadDataHandler(obj) {
      console.debug('uploadDataHandler:', obj)
      this.postUploadObj.dataItemId = this.globalQuery.dataItemId
      this.postUploadObj.imageCode = [obj.imgdata]
      if (obj.legendData) {
        this.postUploadObj.legendData = obj.legendData
      }
      // console.debug(this.postUploadObj)
      this.postUploadImage(this.postUploadObj) //上传图片
    },
  },
}
</script>

<style lang="scss" scoped>
.autoExportPngMain {
  width: 100%;
  height: auto;
}
</style>
